module.exports = __webpack_public_path__ + "static/media/menu3.aa331bd1.png";